import { render, staticRenderFns } from "./ButtonSurveySendInvitations.vue?vue&type=template&id=c85cd8b6&"
import script from "./ButtonSurveySendInvitations.vue?vue&type=script&lang=ts&"
export * from "./ButtonSurveySendInvitations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
